import React from 'react';
import Modal from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Button from "@amzn/meridian/button";
import TrendChart from "./TrendChart";
import { INBOUND_STRINGS } from "../util/Constants";
import './Inbound.css';

const ChartExpandModal = ({open, onClose, title, trendData, tableData}) => {
    trendData = trendData || [];
    tableData = tableData || [];
    
    return (
        <Modal
            open={open}
            onClose={onClose}
            closeLabel={INBOUND_STRINGS.CLOSE}
            scrollContainer="modal"
            width="900px"
        >
            <Column spacing="medium" spacingInset="medium">
                <Text type="h300">{title}</Text>

                <div className="expanded-chart-container">
                    <TrendChart trendData={trendData} height={350} />
                </div>

                {tableData && tableData.length > 0 && (
                    <React.Fragment>
                        <Text type="h200">{INBOUND_STRINGS.DATA_TABLE_VIEW}</Text>
                        <table className="modal-data-table">
                            <thead>
                                <tr>
                                    <th>{INBOUND_STRINGS.TIME}</th>
                                    <th>{INBOUND_STRINGS.ACTUAL_PPH}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.filter(row => row && row.time).map(function(row, index) {
                                    return (
                                        <tr key={index}>
                                            <td>{row.date ? `${row.date} ${row.time}` : row.time}</td>
                                            <td>{((row && row.actual) || 0).toLocaleString()}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </React.Fragment>
                )}

                <Row alignmentHorizontal="right">
                    <Button type="secondary" onClick={onClose}>{INBOUND_STRINGS.CLOSE}</Button>
                </Row>
            </Column>
        </Modal>
    );
};

export default ChartExpandModal;



// WEBPACK FOOTER //
// ./src/components/inbound/ChartExpandModal.js